const adminPanel = {
  adminPanel: {
    einAdmin: 'EIN Admin',
    einInstallerSetup: 'EIN Installer Setup',
    installerDataUpdate: 'Installer Data Update',
    uploadFile: 'Upload File',
    chooseFile: 'Choose File',
    installerDataUpdateDescription: 'Enphase Installer market share, executive sponsor information etc.',
    header: 'Header Bar Links',
    platinumTier: 'Platinum Tier',
    goldTier: 'Gold Tier',
    silverTier: 'Silver Tier',
    same: 'Same for all tiers',
    bannerDescription: 'Banner Description',
    bannerLink: 'Banner Link',
    digitalAssets: 'Digital Assets',
    name: 'Name',
    file: 'File',
    access: 'Access to Tier Category',
    action: 'Action',
    all: 'All',
    platinum: 'Platinum',
    gold: 'Gold',
    silver: 'Silver',
    addDigital: 'Add Digital Assets',
    productInformation: 'Product Information',
    productName: 'Product Name',
    learnMoreLink: 'Learn More Link',
    featureName: 'A/B Feature Name',
    featureType: 'Feature Type',
    betaRelease: 'Beta Release Date',
    addProduct: 'Add Product Information',
    exclusiveUpdate: 'Exclusive Update Links',
    description: 'Description',
    link: 'Link',
    addLink: 'Add Link',
    one: '1.',
    two: '2.',
    installerList: 'Installer list for Product Access',
    usa: 'USA',
    usa_pr: 'USA - Puerto Rico',
    australia: 'Australia',
    belgium: 'Belgium',
    netherlands: 'Netherlands',
    germany: 'Germany',
    india: 'India',
    mexico: 'Mexico',
    france: 'France',
    country: 'Country: ',
    fileName: 'File Name',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'File is empty',
    invalidFileFormat: 'Invalid file format',
    invalidFileHeader: 'Invalid file header',
    uploadFailed: 'Failed to upload file',
    invalidFile: 'Invalid file',
    errorDetail: {
      one: '%{errorCount} out of %{count} row failed.',
      other: '%{errorCount} out of %{count} rows failed.'
    },
    viewError: 'View Errors',
    errorListText: 'File Upload Error List',
    companyId: 'Company ID',
    message: 'Message',
    sampleFileName: 'Sample File'
  }
};

export default adminPanel;
